module.exports = __webpack_public_path__ + "img/mbr-poly.9859afa0.svg";